import React, { useEffect, useState } from 'react';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { Avatar, Button, CssBaseline, TextField, Box, Container } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login } from '../../../redux/auth';
import Warning from '../../common/alert/Warning';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';
import { ApiService } from '../../services/apiService';
import axios from 'axios';

const theme = createTheme();

export default function LoginForm() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("@finedigital.com");
  const [password, setPassword] = useState("");
  const [otpPassword, setOtpPassword] = useState("");
  const authData = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const [openWarning, setOpenWarning] = useState(false);
	const [errorMsg, setErrorMsg] = useState('');
  const [loginConn, setLoginConn] = useState(true);
  const [authenticator, setAuthenticator] = useState(false);
  const [qrImage, setQrImage] = useState(null);

  useEffect(() => {
		if(authData.isLoggedIn === "false") {
			// window.history.forward();
      // navigate(-1);
      navigate("/",  { replace: true});
		}
	}, []);

  useEffect(() => {
		// checkConnectIP();
	}, []);

  const checkConnectIP = async () => {
    // const ipData = await fetch('https://geolocation-db.com/json/');
    // const locationIp = await ipData.json();
    // console.log('iptest', locationIp.IPv4);
    // const ipData = await axios.get('https://api.ipify.org?format=json');
    const ipData = await axios.get('https://api64.ipify.org/?format=json');
    // const ipData = await axios.get('http://cloud-api.finevu.com:4001/myip');
    console.log('iptest', ipData.data);
    if(ipData.data.ip === '58.225.73.106') {
      setLoginConn(true);
    } else {
      setLoginConn(false);
    }
  }

  const closeWarning = (data) => {
		setOpenWarning(data);
	}

  const changeId = (e) => {
    setEmail(e.target.value);
  }

  const changePass = (e) => {
    setPassword(e.target.value);
  }

  const changeOtpPass = (e) => {
    setOtpPassword(e.target.value);
  }

  const loginClick = (e) => {
    e.preventDefault();
    if(email === "" || password === "") {
      setOpenWarning(true);
			setErrorMsg('아이디 또는 패스워드를 입력해주세요!');
    } else {
      dispatch(login({email: email, password: password}))
      .unwrap()
      .then((response) => {
        if(response.user.token) {
          if(!response.user.otpAuth) {
            // 소켓 연결보다 일찍 타면 안되서 setTimeout 걸어둠
            setTimeout(getOtpQrCode, 1000);
            // getOtpQrCode();
          }
          setTimeout(() => {setAuthenticator(true); }, 1200);
        }
      })
      .catch((error) => {
        console.log('LoginForm - loginClick - error :: ', error);
        setOpenWarning(true);
			  setErrorMsg(error.message);
        setAuthenticator(false);
        setQrImage(null);
      })
    }
  };

  const getOtpQrCode = async () => {
    try {
      const qrAuthData = await ApiService.qrCheck();
      setQrImage(qrAuthData.data.qrcode)
    } catch(error) {
      console.log('LoginForm - getOtpQrCode - error :: ', error);
    }
  }

  const otpLoginClick = async (e) => {
    e.preventDefault();
    if(otpPassword === "") {
      setOpenWarning(true);
		  setErrorMsg('Google OTP 코드를 입력하세요!');
    } else {
      let otpLoginResult = null;
      try {
        if(!authData.user.otpAuth) {
          otpLoginResult = await ApiService.updateOtpAuth({otp: otpPassword});
        } else {
          otpLoginResult = await ApiService.otpLogin({otp: otpPassword});
        }
        if(!otpLoginResult.data.message === "success.") {
          setOpenWarning(true);
				  setErrorMsg("fail");
        } else {
          navigate("/", {replace: true});
        }
      } catch (error) {     
        console.log('LoginForm - otpLoginClick - error ::', error)
				setOpenWarning(true);
				setErrorMsg(error.response.data.message);
      }
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="xs" >
        <CssBaseline />
          { (loginConn === true) && (
            <>
              <Box
                sx={{
                  paddingTop: '120px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                  <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5" sx={{ mb: 1}}>
                  Sign in
                </Typography>
                <Box component="form" noValidate sx={{ mt: 1, width: '100%'}}>
                  <TextField
                    value={email}
                    onChange={changeId}
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label="Email"
                    name="email"
                    autoComplete="email"
                  />
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    value={password}
                    onChange={changePass}
                    name="password"
                    label="Password"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    sx={{mb : 2}}
                  />
                  {
                    authenticator ? (
                      <>
                        { (qrImage && (!authData.user.otpAuth)) ? (
                          <img src={qrImage} style={{width: "150px", height: "150px", border: "1px black solid", margin: "auto", display: "block"}} alt="qr" />
                        ) : null}
                        <TextField
                          margin="normal"
                          required
                          fullWidth
                          value={otpPassword}
                          onChange={changeOtpPass}
                          name="Authenticator Code (Google)"
                          label="Authenticator Code (Google)"
                          // type="password"
                          id="otpPassword"
                          autoComplete="current-password"
                        />
                      </>
                    ) : null
                  }
                  {
                    authenticator ? (
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        onClick={otpLoginClick}
                        sx={{ mt: 2, mb: 2, p: 1.5}}
                      >
                        Sign In
                      </Button>
                    ) : (
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        onClick={loginClick}
                        sx={{ mt: 2, mb: 2, p: 1.5}}
                      >
                        Sign In
                      </Button>
                    )
                  }
                </Box>
              </Box>
            </>
          )}

          { (loginConn === false) && (
            <Box
              sx={{
                height: '100vh',
                display: 'flex', 
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div style={{width: '500px',}}>
                <div style={{textAlign: 'center'}}>
                  <WarningAmberRoundedIcon 
                    sx={{fontSize: '150px', color: '#a21212'}}
                  />
                </div>
                <div style={{textAlign: 'center', fontSize: '25px', fontWeight: 'bold', marginTop: '20px' }}>외부망에서는 접속할 수 없습니다.</div>
              </div>
            </Box>
          )}
      </Container>

      <Warning
				open={openWarning}
				onHideWarning={closeWarning}
				warningMsg={errorMsg}
			></Warning>
    </ThemeProvider>
  );
}